// cSpell:disable
import { UUID } from "uuidv7"

import type { EntityMediaType } from "~/models/polyschema/EntityMediaType"

import { EntityMimeTypeIdBuf as EntityMimeTypeId, EntityPropertyGroupIdBuf } from "../generated/entity"

export { DatagramErrorTypeBuf as DatagramErrorType } from "../generated/datagram"

export { EntityApiIdBuf as EntityApiId, EntityMimeTypeIdBuf as EntityMimeTypeId, EntityPropertyGroupIdBuf as PropertyGroup, EntityPropertySchemaBuf as PropertySchema, EntityPropertyStatusBuf as PropertyStatus } from "../generated/entity"

export { EmbeddingsStatusCodeBuf as EmbeddingsStatusCode, LoadStatusCodeBuf as LoadStatusCode, MetadataExtractionStatusCodeBuf as MetadataExtractionStatusCode, MetadataIndexingStatusCodeBuf as MetadataIndexingStatusCode, ThumbnailStatusCodeBuf as ThumbnailStatusCode, TranscodeStatusCodeBuf as TranscodeStatusCode } from "../generated/file"
export enum PropertyId {
  FOLDER_USAGE_UPDATED_AT = "000000ff-00000000-0000-0000-0000-00000000000e",
  FOLDER_USAGE_SIZE = "000000ff-00000000-0000-0000-0000-00000000000f",
  FOLDER_USAGE_QUANTITY = "000000ff-00000000-0000-0000-0000-000000000010",
  USER_HOME_DIR_OWNER_ID = "00000100-00000000-0000-0000-0000-000000000000",
  SHARED_FOLDER_OWNER_ID = "00000100-00000000-0000-0000-0000-000000000001",
  CORRESPONDING_HOME_ID = "00000100-00000000-0000-0000-0000-000000000002",
  CORRESPONDING_ARCHIVE_ID = "00000100-00000000-0000-0000-0000-000000000003",
  FILE_IS_PERMANENTLY_DELETED = "00000100-00000000-0000-0000-0000-000000000004",
  FILE_PUBLIC_USER_ROLE = "00000100-00000000-0000-0000-0000-000000000005",
  FILE_PARENT_ID = "00000100-00000000-0000-0000-0000-000000000006",
  FILE_PARENT_ID_TOMBSTONE = "00000100-00000000-0000-0000-0000-00000000007d",
  FILE_URI = "00000101-00000000-0000-0000-0000-000000000007",
  FILE_NAME = "00000101-00000000-0000-0000-0000-000000000008",
  FILE_CREATED_AT = "00000101-00000000-0000-0000-0000-000000000009",
  FILE_ACCESSED_AT = "00000102-00000000-0000-0000-0000-00000000000a",
  FILE_MIME_TYPE = "00000100-00000000-0000-0000-0000-00000000000b",
  LINK_DESTINATION_URL = "00000101-00000000-0000-0000-0000-000000000022",
  FILE_SHARED_FOLDER_HANDLE = "00000101-00000000-0000-0000-0000-00000000006e",
  FILE_SIZE = "00000102-00000000-0000-0000-0000-00000000000c",
  FILE_MODIFIED_AT = "00000102-00000000-0000-0000-0000-00000000000d",
  THUMBNAIL_SET = "00000102-00000000-0000-0000-0000-000000000075",
  MEDIA_WIDTH_PX = "00000102-00000000-0000-0000-0000-00000000001c",
  MEDIA_HEIGHT_PX = "00000102-00000000-0000-0000-0000-00000000001d",
  MEDIA_WIDTH_CM = "00000102-00000000-0000-0000-0000-000000000020",
  MEDIA_HEIGHT_CM = "00000102-00000000-0000-0000-0000-000000000021",
  MEDIA_DURATION_MS = "00000102-00000000-0000-0000-0000-00000000001e",
  MEDIA_PAGES = "00000102-00000000-0000-0000-0000-00000000001a",
  TEXT_SNIPPET = "00000102-00000000-0000-0000-0000-000000000074",
  FILE_NOTES = "00002000-00000000-0000-0000-0000-000000000024",
  FILE_RATING = "00002000-00000000-0000-0000-0000-000000000025",
  FILE_GENERATION_PROMPT = "00002000-00000000-0000-0000-0000-000000000026",
  FILE_GENERATION_NEGATIVE_PROMPT = "00002000-00000000-0000-0000-0000-000000000027",
  FILE_GENERATION_SOURCE = "00002000-00000000-0000-0000-0000-000000000028",
  FILE_GENERATION_SEED = "00002000-00000000-0000-0000-0000-000000000029",
  FILE_GENERATION_MODEL = "00002000-00000000-0000-0000-0000-00000000002a",
  FILE_GENERATION_MODEL_VERSION = "00002000-00000000-0000-0000-0000-00000000002b",
  FILE_PDF_URI = "00002000-00000000-0000-0000-0000-00000000007c",
  FILE_DOWNLOAD_SOURCE_URL = "00002000-00000000-0000-0000-0000-000000000030",
  FILE_DOWNLOAD_SOURCE_APPLICATION = "00002000-00000000-0000-0000-0000-000000000031",
  FOLDER_VIEW_MODE = "00002300-00000000-0000-0000-0000-00000000001b",
  IMAGE_EXIF_JSON = "00002450-00000000-0000-0000-0000-00000000002c",
  AUDIO_CONTAINER_METADATA = "00002550-00000000-0000-0000-0000-00000000002d",
  VIDEO_CONTAINER_METADATA = "00002650-00000000-0000-0000-0000-000000000076",
  LINK_OPEN_GRAPH_METADATA = "00002850-00000000-0000-0000-0000-000000000042",
  PDF_CONTAINER_METADATA = "00002950-00000000-0000-0000-0000-00000000006b",
  FILE_COPY_ORIGIN_ID = "00000103-00000000-0000-0000-0000-000000000047",
  FILE_SHA256_CHECKSUM = "00000102-00000000-0000-0000-0000-000000000048",
  FILE_SEARCH_INDEXING_STATUS = "00000103-00000000-0000-0000-0000-000000000060",
  FILE_CLIENT_PROPERTY_SELECTION = "0000ff00-00000000-0000-0000-0000-000000000049",
  FILE_VIRTUAL_PRE_HASH = "0000ff00-00000000-0000-0000-0000-00000000002f",
  FILE_VIRTUAL_MEDIA_TYPE = "0000ff00-00000000-0000-0000-0000-000000000045",
  FILE_VIRTUAL_FULL_TEXT = "0000ff00-00000000-0000-0000-0000-000000000046",
  FILE_VIRTUAL_EVERYTHING = "0000ff00-00000000-0000-0000-0000-000000000043",
  FILE_VIRTUAL_CONTENTS = "0000ff00-00000000-0000-0000-0000-00000000002e",
  FILE_VIRTUAL_EMBEDDINGS = "0000ff00-00000000-0000-0000-0000-000000000078",
  FILE_VIRTUAL_PAGE_EMBEDDINGS = "0000ff00-00000000-0000-0000-0000-00000000007a",
  FILE_VIRTUAL_PREVIEW = "0000ff00-00000000-0000-0000-0000-00000000004a",
  FILE_VIRTUAL_DIMENSIONS = "0000ff00-00000000-0000-0000-0000-00000000004b",
  FILE_VIRTUAL_TAGS = "0000ff00-00000000-0000-0000-0000-00000000004c",
  FILE_VIRTUAL_PATH = "0000ff00-00000000-0000-0000-0000-00000000004d",
  FILE_VIRTUAL_SEARCH_RELEVANCE = "0000ff00-00000000-0000-0000-0000-00000000004e",
  FILE_VIRTUAL_ADDED_AT = "0000ff00-00000000-0000-0000-0000-00000000005e",
  FILE_VIRTUAL_SELF_ROLE = "0000ff00-00000000-0000-0000-0000-00000000005f",
  FOLDER_CLIENT_REQUEST = "0000ff00-00000000-0000-0000-0000-00000000004f",
  USER_HANDLE = "00010010-00000000-0000-0000-0000-000000000058",
  USER_EMAIL = "00010010-00000000-0000-0000-0000-000000000050",
  USER_AVATAR_URI = "00010010-00000000-0000-0000-0000-000000000051",
  USER_CREATED_AT = "00010010-00000000-0000-0000-0000-000000000053",
  USER_GLOBAL_DEFAULT_VIEW_MODE = "00010050-00000000-0000-0000-0000-000000000052",
  USER_LATEST_VIEW_MODE = "00010050-00000000-0000-0000-0000-000000000063",
  USER_LATEST_ICON_VIEW_MODE = "00010050-00000000-0000-0000-0000-000000000064",
  USER_LATEST_GRID_VIEW_MODE = "00010050-00000000-0000-0000-0000-000000000065",
  USER_LATEST_DETAIL_VIEW_MODE = "00010050-00000000-0000-0000-0000-000000000066",
  USER_LATEST_FEED_VIEW_MODE = "00010050-00000000-0000-0000-0000-000000000067",
  USER_LATEST_COLUMN_VIEW_MODE = "00010050-00000000-0000-0000-0000-000000000068",
  USER_LATEST_TREE_VIEW_MODE = "00010050-00000000-0000-0000-0000-000000000069",
  USER_LATEST_TABLE_VIEW_MODE = "00010050-00000000-0000-0000-0000-00000000006a",
  USER_LATEST_GALLERY_VIEW_MODE = "00010050-00000000-0000-0000-0000-000000000044",
  USER_DEFAULT_SIDEBAR = "00010050-00000000-0000-0000-0000-000000000070",
  USER_INTERFACE_SETTINGS = "00010050-00000000-0000-0000-0000-00000000007b",
  USER_CLIENT_ACCESS_ID = "0001ff00-00000000-0000-0000-0000-000000000054",
  USER_IS_VERIFIED = "00010000-00000000-0000-0000-0000-000000000055",
  SHARED_FOLDER_DISPLAY_NAME = "00020101-00000000-0000-0000-0000-000000000056",
  SHARED_FOLDER_CREATED_AT = "00020101-00000000-0000-0000-0000-000000000057",
  SHARED_FOLDER_IS_PERMANENTLY_DELETED = "00020100-00000000-0000-0000-0000-000000000059",
  CONVERSATION_CREATED_AT = "00040000-00000000-0000-0000-0000-00000000007f",
  CONVERSATION_ARTIFACTS_FOLDER_ID = "00040000-00000000-0000-0000-0000-000000000082",
  CONVERSATION_IS_DELETED = "00040000-00000000-0000-0000-0000-00000000006d",
  CONVERSATION_USER_TITLE = "00040000-00000000-0000-0000-0000-00000000006f",
  SEARCH_CREATED_AT = "00050000-00000000-0000-0000-0000-00000000005a",
  SEARCH_USER = "00050000-00000000-0000-0000-0000-00000000005b",
  SEARCH_DESCRIPTION = "00050000-00000000-0000-0000-0000-000000000061",
  SEARCH_DEFINITION = "00050000-00000000-0000-0000-0000-000000000073",
  SEARCH_LOCATIONS = "00050010-00000000-0000-0000-0000-000000000072",
  SEARCH_EXECUTED_AT = "00050010-00000000-0000-0000-0000-00000000005c",
  SEARCH_CLIENT_PROPERTIES = "00050010-00000000-0000-0000-0000-000000000062",
}
/** A pre-created set object to check for inclusion in properties */
export const Properties: Set<string> = new Set([...Object.values(PropertyId)])
export const VirtualProperties: Set<string> = new Set([
  PropertyId.FILE_VIRTUAL_PREVIEW,
  PropertyId.FILE_VIRTUAL_DIMENSIONS,
  PropertyId.FILE_VIRTUAL_TAGS,
  PropertyId.FILE_VIRTUAL_PATH,
  PropertyId.FILE_VIRTUAL_SEARCH_RELEVANCE,
])

export function propertyName(propertyId: PropertyId) {
  const directName = ({
    [PropertyId.FILE_NAME]: "Name",
    [PropertyId.FILE_SIZE]: "File Size",
    [PropertyId.FILE_PARENT_ID]: "Location",
    [PropertyId.FILE_NOTES]: "Notes",
    [PropertyId.FILE_RATING]: "Rating",
    [PropertyId.FILE_DOWNLOAD_SOURCE_URL]: "Downloaded From",
    [PropertyId.FILE_DOWNLOAD_SOURCE_APPLICATION]: "Downloaded With",
    [PropertyId.FILE_GENERATION_PROMPT]: "Gen. Prompt",
    [PropertyId.FILE_GENERATION_NEGATIVE_PROMPT]: "Gen. Negative Prompt",
    [PropertyId.FILE_GENERATION_SOURCE]: "Gen. Source",
    [PropertyId.FILE_GENERATION_MODEL]: "Gen. Model",
    [PropertyId.FILE_GENERATION_MODEL_VERSION]: "Gen. Model Version",
    [PropertyId.FILE_GENERATION_SEED]: "Gen. Seed",
    [PropertyId.FILE_VIRTUAL_PREVIEW]: "Preview",
    [PropertyId.FILE_VIRTUAL_PATH]: "Path",
    [PropertyId.FILE_VIRTUAL_TAGS]: "Tags",
    [PropertyId.FILE_VIRTUAL_SEARCH_RELEVANCE]: "Search Relevance",
    [PropertyId.FILE_VIRTUAL_SELF_ROLE]: "Permissions",
    [PropertyId.FILE_CREATED_AT]: "Created at",
    [PropertyId.FILE_MODIFIED_AT]: "Modified at",
    [PropertyId.FILE_ACCESSED_AT]: "Accessed at",
    [PropertyId.FILE_VIRTUAL_ADDED_AT]: "Moved at",
    [PropertyId.FILE_MIME_TYPE]: "MIME Type",
    [PropertyId.FILE_VIRTUAL_MEDIA_TYPE]: "Media Kind",
    [PropertyId.MEDIA_PAGES]: "Page Count",
    [PropertyId.FILE_VIRTUAL_DIMENSIONS]: "Media Dimensions",
    [PropertyId.MEDIA_WIDTH_PX]: "Media Width (px)",
    [PropertyId.MEDIA_HEIGHT_PX]: "Media Height (px)",
    [PropertyId.MEDIA_WIDTH_CM]: "Media Phys. Width (cm)",
    [PropertyId.MEDIA_HEIGHT_CM]: "Media Phys. Height (cm)",
    [PropertyId.MEDIA_DURATION_MS]: "Media Duration (ms)",
  } as Record<PropertyId, string>)[propertyId]
  if (directName)
    return directName
  if (groupFor(propertyId) === EntityPropertyGroupIdBuf.FileTagMetaProperty)
    return "Tags"
  return "Unknown"
}

/**
 * This is used in the UI wherever the property has an icon:
 * - table view mode
 * - property filtering/sorting
 */
export function propertyIcon(propertyId: PropertyId): PropertyIconType {
  switch (propertyId) {
    case PropertyId.FILE_NAME: return "name"
    case PropertyId.FILE_SIZE: return "size"
    case PropertyId.LINK_DESTINATION_URL: return "external"
    case PropertyId.FILE_VIRTUAL_PREVIEW: return "image"
    case PropertyId.FILE_VIRTUAL_PATH: return "path"
    case PropertyId.FILE_CREATED_AT: return "created"
    case PropertyId.FILE_MODIFIED_AT: return "modified"
    case PropertyId.FILE_ACCESSED_AT: return "date"
    case PropertyId.FILE_VIRTUAL_ADDED_AT: return "date"
    case PropertyId.MEDIA_WIDTH_PX: return "dimensions"
    case PropertyId.MEDIA_WIDTH_CM: return "dimensions"
    case PropertyId.MEDIA_HEIGHT_PX: return "dimensions"
    case PropertyId.MEDIA_HEIGHT_CM: return "dimensions"
    case PropertyId.MEDIA_PAGES: return "file"
    case PropertyId.FILE_VIRTUAL_DIMENSIONS: return "dimensions"
    case PropertyId.FILE_VIRTUAL_TAGS: return "tags"
    case PropertyId.FILE_NOTES: return "header"
    case PropertyId.FILE_RATING: return "prompt"
    case PropertyId.FILE_GENERATION_PROMPT: return "prompt"
    case PropertyId.FILE_GENERATION_NEGATIVE_PROMPT: return "negprompt"
    case PropertyId.FILE_GENERATION_SOURCE: return "prompt"
    case PropertyId.FILE_GENERATION_MODEL: return "prompt"
    case PropertyId.FILE_GENERATION_SEED: return "prompt"
    case PropertyId.AUDIO_CONTAINER_METADATA: return "audio"
    case PropertyId.VIDEO_CONTAINER_METADATA: return "video"
    case PropertyId.PDF_CONTAINER_METADATA: return "pdf"
    case PropertyId.LINK_OPEN_GRAPH_METADATA: return "public"
    case PropertyId.IMAGE_EXIF_JSON: return "image"
    default: return "metadata"
  }
}

function _metapropertyUuid(groupId: EntityPropertyGroupIdBuf, uuid: string) {
  if (uuid.length !== 36) // uuid v7
    throw new Error("Invalid uuid provided")
  const pid = `${groupId.toString(16).padStart(8, "0")}-${uuid}`
  if (pid.length !== 45)
    throw new Error("Invalid result")
  return pid as PropertyId
}

function _metapropertyEntityId(groupId: EntityPropertyGroupIdBuf, entityId: string) {
  if (entityId.length !== 45) // entity id extended uuid
    throw new Error("Invalid entity id provided")
  const uuid = entityId.slice(9)
  return _metapropertyUuid(groupId, uuid)
}

/** Generates the property id for the "shared-with" property on files */
export function sharedWith(userId: string) {
  return _metapropertyEntityId(
    EntityPropertyGroupIdBuf.FileSharingUsersMetaProperty,
    userId,
  )
}

/** Generates the property id for the "conversation turn" property on conversations */
export function conversationTurns(timestamp: string) {
  return _metapropertyUuid(
    EntityPropertyGroupIdBuf.ConversationTurnsMetaProperty,
    timestamp,
  )
}

export function orderedId(groupId: PropertyGroup, index: number) {
  const values = new Float64Array(2)
  values[0] = 0
  values[1] = index
  const bytes = values.buffer
  const uuid = UUID.ofInner(new Uint8Array(bytes))
  return _metapropertyUuid(groupId, uuid.toString())
}

export function conversationMember(userId: string) {
  return _metapropertyEntityId(EntityPropertyGroupIdBuf.ConversationSharingUsersMetaProperty, userId)
}

export function groupFor(propertyId: PropertyId): PropertyGroup {
  return Number.parseInt(propertyId.slice(0, 8), 16)
}

export function keyFor(propertyId: PropertyId): string {
  const uuid = partition(propertyId, "-")[1]
  if (!uuid)
    throw new Error(`Property id invalid: ${propertyId}`)
  return uuid
}

export function apiIdFor(entityId: string): EntityApiId {
  return Number.parseInt(entityId.slice(0, 8), 16)
}

/**
 * Taken from https://park.is/blog_posts/20240803_extracting_timestamp_from_uuid_v7/
 * @param uuid a uuidv7 timestamp
 * @returns a javascript date
 */
export function dateFromTimestampUuid(uuid: string): Date {
  // split the UUID into its components
  const parts = uuid.split("-")
  // the second part of the UUID contains the high bits of the timestamp (48 bits in total)
  const highBitsHex = parts[0] + parts[1].slice(0, 4)
  // convert the high bits from hex to decimal
  // the UUID v7 timestamp is the number of milliseconds since Unix epoch (January 1, 1970)
  const timestampInMilliseconds = Number.parseInt(highBitsHex, 16)
  // convert the timestamp to a Date object
  const date = new Date(timestampInMilliseconds)
  return date
}

export function hasGroup(propertyId: PropertyId, groupId: PropertyGroup) {
  return enumEq(groupFor(propertyId), groupId)
}

export function asTimestampMillis(timestamp: string) {
  const uuid = UUID.parse(timestamp)
  const bytes = uuid.bytes
  const timestampBytes = new Uint8Array(8)
  timestampBytes.set(new Uint8Array(bytes.slice(0, 6)), 2)
  const timestampMs = new DataView(timestampBytes.buffer).getBigUint64(0)
  return Number(timestampMs)
}

export function mimeTypeString(mimeType: EntityMimeType) {
  // cSpell:disable
  switch (mimeType.value) {
    case EntityMimeTypeId.Unknown: return mimeType.unknown
    case EntityMimeTypeId.ApplicationBc: return "application/x-llvm"
    case EntityMimeTypeId.ApplicationClass: return "application/java"
    case EntityMimeTypeId.ApplicationExe: return "application/vnd.microsoft.portable-executable"
    case EntityMimeTypeId.ApplicationJavascript: return "application/javascript"
    case EntityMimeTypeId.ApplicationJson: return "application/json"
    case EntityMimeTypeId.ApplicationMach: return "application/x-mach-binary"
    case EntityMimeTypeId.ApplicationMsgpack: return "application/msgpack"
    case EntityMimeTypeId.ApplicationObj: return "application/x-executable"
    case EntityMimeTypeId.ApplicationOctetStream: return "application/octet-stream"
    case EntityMimeTypeId.ApplicationPdf: return "application/pdf"
    case EntityMimeTypeId.ApplicationWasm: return "application/wasm"
    case EntityMimeTypeId.ApplicationWwwFormUrlencoded: return "application/x-www-form-urlencoded"
    case EntityMimeTypeId.Archive7z: return "application/x-7z-compressed"
    case EntityMimeTypeId.ArchiveAr: return "application/x-unix-archive"
    case EntityMimeTypeId.ArchiveBz2: return "application/x-bzip2"
    case EntityMimeTypeId.ArchiveCab: return "application/vnd.ms-cab-compressed"
    case EntityMimeTypeId.ArchiveCpio: return "application/x-cpio"
    case EntityMimeTypeId.ArchiveCrx: return "application/x-google-chrome-extension"
    case EntityMimeTypeId.ArchiveDcm: return "application/dicom"
    case EntityMimeTypeId.ArchiveDeb: return "application/vnd.debian.binary-package"
    case EntityMimeTypeId.ArchiveGz: return "application/gzip"
    case EntityMimeTypeId.ArchiveLz: return "application/x-lzip"
    case EntityMimeTypeId.ArchiveMsi: return "application/x-ole-storage"
    case EntityMimeTypeId.ArchiveNes: return "application/x-nintendo-nes-rom"
    case EntityMimeTypeId.ArchivePs: return "application/postscript"
    case EntityMimeTypeId.ArchiveRar: return "application/vnd.rar"
    case EntityMimeTypeId.ArchiveRpm: return "application/x-rpm"
    case EntityMimeTypeId.ArchiveRtf: return "application/rtf"
    case EntityMimeTypeId.ArchiveSqlite: return "application/vnd.sqlite3"
    case EntityMimeTypeId.ArchiveSwf: return "application/x-shockwave-flash"
    case EntityMimeTypeId.ArchiveTar: return "application/x-tar"
    case EntityMimeTypeId.ArchiveXz: return "application/x-xz"
    case EntityMimeTypeId.ArchiveZ: return "application/x-compress"
    case EntityMimeTypeId.ArchiveZip: return "application/zip"
    case EntityMimeTypeId.ArchiveZst: return "application/zstd"
    case EntityMimeTypeId.AudioAac: return "audio/aac"
    case EntityMimeTypeId.AudioAiff: return "audio/x-aiff"
    case EntityMimeTypeId.AudioAmr: return "audio/amr"
    case EntityMimeTypeId.AudioApe: return "audio/x-ape"
    case EntityMimeTypeId.AudioDsf: return "audio/x-dsf"
    case EntityMimeTypeId.AudioFlac: return "audio/x-flac"
    case EntityMimeTypeId.AudioM4a: return "audio/m4a"
    case EntityMimeTypeId.AudioMidi: return "audio/midi"
    case EntityMimeTypeId.AudioMp3: return "audio/mpeg"
    case EntityMimeTypeId.AudioMp4: return "audio/mp4"
    case EntityMimeTypeId.AudioOgg: return "audio/ogg"
    case EntityMimeTypeId.AudioOpus: return "audio/opus"
    case EntityMimeTypeId.AudioWav: return "audio/x-wav"
    case EntityMimeTypeId.BookEpub: return "application/epub+zip"
    case EntityMimeTypeId.BookMobi: return "application/x-mobipocket-ebook"
    case EntityMimeTypeId.DocDoc: return "application/msword"
    case EntityMimeTypeId.DocDocx: return "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    case EntityMimeTypeId.DocOdt: return "application/vnd.oasis.opendocument.text"
    case EntityMimeTypeId.DocPages: return "application/vnd.apple.pages"
    case EntityMimeTypeId.FontOtf: return "font/otf"
    case EntityMimeTypeId.FontTtf: return "font/ttf"
    case EntityMimeTypeId.FontWoff: return "font/woff"
    case EntityMimeTypeId.FontWoff2: return "font/woff2"
    case EntityMimeTypeId.ImageAvif: return "image/avif"
    case EntityMimeTypeId.ImageBmp: return "image/bmp"
    case EntityMimeTypeId.ImageCr2: return "image/x-canon-cr2"
    case EntityMimeTypeId.ImageGif: return "image/gif"
    case EntityMimeTypeId.ImageHeic: return "image/heic"
    case EntityMimeTypeId.ImageHeif: return "image/heif"
    case EntityMimeTypeId.ImageIco: return "image/vnd.microsoft.icon"
    case EntityMimeTypeId.ImageJp2: return "image/jp2"
    case EntityMimeTypeId.ImageJpeg: return "image/jpeg"
    case EntityMimeTypeId.ImageJxl: return "image/jxl"
    case EntityMimeTypeId.ImageJxr: return "image/vnd.ms-photo"
    case EntityMimeTypeId.ImageOra: return "image/openraster"
    case EntityMimeTypeId.ImagePng: return "image/png"
    case EntityMimeTypeId.ImagePpm: return "image/ppm"
    case EntityMimeTypeId.ImagePsd: return "image/vnd.adobe.photoshop"
    case EntityMimeTypeId.ImageQoi: return "image/qoi"
    case EntityMimeTypeId.ImageStar: return "image/*"
    case EntityMimeTypeId.ImageSvg: return "image/svg+xml"
    case EntityMimeTypeId.ImageTif: return "image/tiff"
    case EntityMimeTypeId.ImageWebp: return "image/webp"
    case EntityMimeTypeId.InodeDirectory: return "inode/directory"
    case EntityMimeTypeId.InodeSymlink: return "inode/symlink"
    case EntityMimeTypeId.MultipartFormData: return "multipart/form-data"
    case EntityMimeTypeId.PresentationKeynote: return "application/vnd.apple.keynote"
    case EntityMimeTypeId.PresentationOdp: return "application/vnd.oasis.opendocument.presentation"
    case EntityMimeTypeId.PresentationPpt: return "application/vnd.ms-powerpoint"
    case EntityMimeTypeId.PresentationPptx: return "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    case EntityMimeTypeId.SpreadsheetNumbers: return "application/vnd.apple.numbers"
    case EntityMimeTypeId.SpreadsheetOds: return "application/vnd.oasis.opendocument.spreadsheet"
    case EntityMimeTypeId.SpreadsheetXls: return "application/vnd.ms-excel"
    case EntityMimeTypeId.SpreadsheetXlsx: return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    case EntityMimeTypeId.TextIcs: return "text/calendar"
    case EntityMimeTypeId.TextCss: return "text/css"
    case EntityMimeTypeId.TextCsv: return "text/csv"
    case EntityMimeTypeId.TextEventStream: return "text/event-stream"
    case EntityMimeTypeId.TextHtml: return "text/html"
    case EntityMimeTypeId.TextJavascript: return "text/javascript"
    case EntityMimeTypeId.TextPhp: return "application/x-httpd-php"
    case EntityMimeTypeId.TextPython: return "text/x-python"
    case EntityMimeTypeId.TextMarkdown: return "text/markdown"
    case EntityMimeTypeId.TextRtf: return "text/rtf"
    case EntityMimeTypeId.TextPlain: return "text/plain"
    case EntityMimeTypeId.TextSh: return "text/x-shellscript"
    case EntityMimeTypeId.TextTabSeparatedValues: return "text/tab-separated-values"
    case EntityMimeTypeId.TextUriList: return "text/uri-list"
    case EntityMimeTypeId.TextVcard: return "text/vcard"
    case EntityMimeTypeId.TextXml: return "text/xml"
    case EntityMimeTypeId.VendorYoutubeVideo: return "application/vnd.youtube.video-url"
    case EntityMimeTypeId.VideoAvi: return "video/x-msvideo"
    case EntityMimeTypeId.VideoFlv: return "video/x-flv"
    case EntityMimeTypeId.VideoM4v: return "video/x-m4v"
    case EntityMimeTypeId.VideoMkv: return "video/x-matroska"
    case EntityMimeTypeId.VideoMov: return "video/quicktime"
    case EntityMimeTypeId.VideoMp4: return "video/mp4"
    case EntityMimeTypeId.VideoMpg: return "video/mpeg"
    case EntityMimeTypeId.VideoWebm: return "video/webm"
    case EntityMimeTypeId.VideoWmv: return "video/x-ms-wmv"
    default: throw new Error(`Unknown mime type found: ${JSON.stringify(mimeType)}`)
  }
}
export function stringToMimeType(mimeType: string): EntityMimeType {
  // cSpell:disable
  switch (mimeType) {
    case "application/x-llvm": return { value: EntityMimeTypeId.ApplicationBc }
    case "application/java": return { value: EntityMimeTypeId.ApplicationClass }
    case "application/vnd.microsoft.portable-executable": return { value: EntityMimeTypeId.ApplicationExe }
    case "application/javascript": return { value: EntityMimeTypeId.ApplicationJavascript }
    case "application/json": return { value: EntityMimeTypeId.ApplicationJson }
    case "application/x-mach-binary": return { value: EntityMimeTypeId.ApplicationMach }
    case "application/msgpack": return { value: EntityMimeTypeId.ApplicationMsgpack }
    case "application/x-executable": return { value: EntityMimeTypeId.ApplicationObj }
    case "application/octet-stream": return { value: EntityMimeTypeId.ApplicationOctetStream }
    case "application/pdf": return { value: EntityMimeTypeId.ApplicationPdf }
    case "application/wasm": return { value: EntityMimeTypeId.ApplicationWasm }
    case "application/x-www-form-urlencoded": return { value: EntityMimeTypeId.ApplicationWwwFormUrlencoded }
    case "application/x-7z-compressed": return { value: EntityMimeTypeId.Archive7z }
    case "application/x-unix-archive": return { value: EntityMimeTypeId.ArchiveAr }
    case "application/x-bzip2": return { value: EntityMimeTypeId.ArchiveBz2 }
    case "application/vnd.ms-cab-compressed": return { value: EntityMimeTypeId.ArchiveCab }
    case "application/x-cpio": return { value: EntityMimeTypeId.ArchiveCpio }
    case "application/x-google-chrome-extension": return { value: EntityMimeTypeId.ArchiveCrx }
    case "application/dicom": return { value: EntityMimeTypeId.ArchiveDcm }
    case "application/vnd.debian.binary-package": return { value: EntityMimeTypeId.ArchiveDeb }
    case "application/gzip": return { value: EntityMimeTypeId.ArchiveGz }
    case "application/x-lzip": return { value: EntityMimeTypeId.ArchiveLz }
    case "application/x-httpd-php": return { value: EntityMimeTypeId.TextPhp }
    case "application/x-ole-storage": return { value: EntityMimeTypeId.ArchiveMsi }
    case "application/x-nintendo-nes-rom": return { value: EntityMimeTypeId.ArchiveNes }
    case "application/postscript": return { value: EntityMimeTypeId.ArchivePs }
    case "application/vnd.rar": return { value: EntityMimeTypeId.ArchiveRar }
    case "application/x-rpm": return { value: EntityMimeTypeId.ArchiveRpm }
    case "application/rtf": return { value: EntityMimeTypeId.ArchiveRtf }
    case "application/vnd.sqlite3": return { value: EntityMimeTypeId.ArchiveSqlite }
    case "application/x-shockwave-flash": return { value: EntityMimeTypeId.ArchiveSwf }
    case "application/x-tar": return { value: EntityMimeTypeId.ArchiveTar }
    case "application/x-xz": return { value: EntityMimeTypeId.ArchiveXz }
    case "application/x-compress": return { value: EntityMimeTypeId.ArchiveZ }
    case "application/zip": return { value: EntityMimeTypeId.ArchiveZip }
    case "application/zstd": return { value: EntityMimeTypeId.ArchiveZst }
    case "audio/aac": return { value: EntityMimeTypeId.AudioAac }
    case "audio/x-aiff": return { value: EntityMimeTypeId.AudioAiff }
    case "audio/amr": return { value: EntityMimeTypeId.AudioAmr }
    case "audio/x-ape": return { value: EntityMimeTypeId.AudioApe }
    case "audio/x-dsf": return { value: EntityMimeTypeId.AudioDsf }
    case "audio/x-flac": return { value: EntityMimeTypeId.AudioFlac }
    case "audio/m4a": return { value: EntityMimeTypeId.AudioM4a }
    case "audio/midi": return { value: EntityMimeTypeId.AudioMidi }
    case "audio/mpeg": return { value: EntityMimeTypeId.AudioMp3 }
    case "audio/mp4": return { value: EntityMimeTypeId.AudioMp4 }
    case "audio/ogg": return { value: EntityMimeTypeId.AudioOgg }
    case "audio/opus": return { value: EntityMimeTypeId.AudioOpus }
    case "audio/x-wav": return { value: EntityMimeTypeId.AudioWav }
    case "application/epub+zip": return { value: EntityMimeTypeId.BookEpub }
    case "application/x-mobipocket-ebook": return { value: EntityMimeTypeId.BookMobi }
    case "application/msword": return { value: EntityMimeTypeId.DocDoc }
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document": return { value: EntityMimeTypeId.DocDocx }
    case "application/vnd.oasis.opendocument.text": return { value: EntityMimeTypeId.DocOdt }
    case "application/vnd.apple.pages": return { value: EntityMimeTypeId.DocPages }
    case "font/otf": return { value: EntityMimeTypeId.FontOtf }
    case "font/ttf": return { value: EntityMimeTypeId.FontTtf }
    case "font/woff": return { value: EntityMimeTypeId.FontWoff }
    case "font/woff2": return { value: EntityMimeTypeId.FontWoff2 }
    case "image/avif": return { value: EntityMimeTypeId.ImageAvif }
    case "image/bmp": return { value: EntityMimeTypeId.ImageBmp }
    case "image/x-canon-cr2": return { value: EntityMimeTypeId.ImageCr2 }
    case "image/gif": return { value: EntityMimeTypeId.ImageGif }
    case "image/heic": return { value: EntityMimeTypeId.ImageHeic }
    case "image/heif": return { value: EntityMimeTypeId.ImageHeif }
    case "image/vnd.microsoft.icon": return { value: EntityMimeTypeId.ImageIco }
    case "image/jp2": return { value: EntityMimeTypeId.ImageJp2 }
    case "image/jpeg": return { value: EntityMimeTypeId.ImageJpeg }
    case "image/jxl": return { value: EntityMimeTypeId.ImageJxl }
    case "image/vnd.ms-photo": return { value: EntityMimeTypeId.ImageJxr }
    case "image/openraster": return { value: EntityMimeTypeId.ImageOra }
    case "image/png": return { value: EntityMimeTypeId.ImagePng }
    case "image/ppm": return { value: EntityMimeTypeId.ImagePpm }
    case "image/vnd.adobe.photoshop": return { value: EntityMimeTypeId.ImagePsd }
    case "image/qoi": return { value: EntityMimeTypeId.ImageQoi }
    case "image/*": return { value: EntityMimeTypeId.ImageStar }
    case "image/svg+xml": return { value: EntityMimeTypeId.ImageSvg }
    case "image/tiff": return { value: EntityMimeTypeId.ImageTif }
    case "image/webp": return { value: EntityMimeTypeId.ImageWebp }
    case "inode/directory": return { value: EntityMimeTypeId.InodeDirectory }
    case "inode/symlink": return { value: EntityMimeTypeId.InodeSymlink }
    case "multipart/form-data": return { value: EntityMimeTypeId.MultipartFormData }
    case "application/vnd.apple.keynote": return { value: EntityMimeTypeId.PresentationKeynote }
    case "application/vnd.oasis.opendocument.presentation": return { value: EntityMimeTypeId.PresentationOdp }
    case "application/vnd.ms-powerpoint": return { value: EntityMimeTypeId.PresentationPpt }
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation": return { value: EntityMimeTypeId.PresentationPptx }
    case "application/vnd.apple.numbers": return { value: EntityMimeTypeId.SpreadsheetNumbers }
    case "application/vnd.oasis.opendocument.spreadsheet": return { value: EntityMimeTypeId.SpreadsheetOds }
    case "application/vnd.ms-excel": return { value: EntityMimeTypeId.SpreadsheetXls }
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": return { value: EntityMimeTypeId.SpreadsheetXlsx }
    case "text/calendar": return { value: EntityMimeTypeId.TextIcs }
    case "text/css": return { value: EntityMimeTypeId.TextCss }
    case "text/csv": return { value: EntityMimeTypeId.TextCsv }
    case "text/event-stream": return { value: EntityMimeTypeId.TextEventStream }
    case "text/html": return { value: EntityMimeTypeId.TextHtml }
    case "text/javascript": return { value: EntityMimeTypeId.TextJavascript }
    case "text/x-python": return { value: EntityMimeTypeId.TextPython }
    case "text/md": return { value: EntityMimeTypeId.TextMarkdown }
    case "text/markdown": return { value: EntityMimeTypeId.TextMarkdown }
    case "text/x-markdown": return { value: EntityMimeTypeId.TextMarkdown }
    case "text/rtf": return { value: EntityMimeTypeId.TextRtf }
    case "text/x-shellscript": return { value: EntityMimeTypeId.TextSh }
    case "text/tab-separated-values": return { value: EntityMimeTypeId.TextTabSeparatedValues }
    case "text/uri-list": return { value: EntityMimeTypeId.TextUriList }
    case "text/vcard": return { value: EntityMimeTypeId.TextVcard }
    case "text/xml": return { value: EntityMimeTypeId.TextXml }
    case "video/x-msvideo": return { value: EntityMimeTypeId.VideoAvi }
    case "video/x-flv": return { value: EntityMimeTypeId.VideoFlv }
    case "video/x-m4v": return { value: EntityMimeTypeId.VideoM4v }
    case "video/x-matroska": return { value: EntityMimeTypeId.VideoMkv }
    case "video/quicktime": return { value: EntityMimeTypeId.VideoMov }
    case "video/mp4": return { value: EntityMimeTypeId.VideoMp4 }
    case "video/mpeg": return { value: EntityMimeTypeId.VideoMpg }
    case "video/webm": return { value: EntityMimeTypeId.VideoWebm }
    case "video/x-ms-wmv": return { value: EntityMimeTypeId.VideoWmv }
    default: return { value: EntityMimeTypeId.Unknown, unknown: mimeType }
  }
}

export function inferMimeTypeFromFilename(filename: string): EntityMimeType {
  filename = filename.toLowerCase()
  const lastDotIndex = filename.lastIndexOf(".")
  if (lastDotIndex === -1)
    return { value: EntityMimeTypeId.Unknown, unknown: "application/octet-stream" }

  const ext = filename.slice(lastDotIndex + 1)
  switch (ext) {
    case "7z": return { value: EntityMimeTypeId.Archive7z }
    case "aac": return { value: EntityMimeTypeId.AudioAac }
    case "aiff": return { value: EntityMimeTypeId.AudioAiff }
    case "amr": return { value: EntityMimeTypeId.AudioAmr }
    case "ape": return { value: EntityMimeTypeId.AudioApe }
    case "ar": return { value: EntityMimeTypeId.ArchiveAr }
    case "avi": return { value: EntityMimeTypeId.VideoAvi }
    case "avif": return { value: EntityMimeTypeId.ImageAvif }
    case "bc": return { value: EntityMimeTypeId.ApplicationBc }
    case "bmp": return { value: EntityMimeTypeId.ImageBmp }
    case "bz2": return { value: EntityMimeTypeId.ArchiveBz2 }
    case "c": return { value: EntityMimeTypeId.TextPlain }
    case "cab": return { value: EntityMimeTypeId.ArchiveCab }
    case "class": return { value: EntityMimeTypeId.ApplicationClass }
    case "clj": return { value: EntityMimeTypeId.TextPlain }
    case "cpio": return { value: EntityMimeTypeId.ArchiveCpio }
    case "cpp": return { value: EntityMimeTypeId.TextPlain }
    case "cr2": return { value: EntityMimeTypeId.ImageCr2 }
    case "crx": return { value: EntityMimeTypeId.ArchiveCrx }
    case "cs": return { value: EntityMimeTypeId.TextPlain }
    case "css": return { value: EntityMimeTypeId.TextCss }
    case "csv": return { value: EntityMimeTypeId.TextCsv }
    case "dart": return { value: EntityMimeTypeId.TextPlain }
    case "dcm": return { value: EntityMimeTypeId.ArchiveDcm }
    case "deb": return { value: EntityMimeTypeId.ArchiveDeb }
    case "dll": return { value: EntityMimeTypeId.ApplicationOctetStream }
    case "doc": return { value: EntityMimeTypeId.DocDoc }
    case "docx": return { value: EntityMimeTypeId.DocDocx }
    case "dsf": return { value: EntityMimeTypeId.AudioDsf }
    case "el": return { value: EntityMimeTypeId.TextPlain }
    case "elf": return { value: EntityMimeTypeId.ApplicationOctetStream }
    case "epub": return { value: EntityMimeTypeId.BookEpub }
    case "ex": return { value: EntityMimeTypeId.TextPlain }
    case "exe": return { value: EntityMimeTypeId.ApplicationExe }
    case "flac": return { value: EntityMimeTypeId.AudioFlac }
    case "flv": return { value: EntityMimeTypeId.VideoFlv }
    case "gif": return { value: EntityMimeTypeId.ImageGif }
    case "go": return { value: EntityMimeTypeId.TextPlain }
    case "gz": return { value: EntityMimeTypeId.ArchiveGz }
    case "heif": return { value: EntityMimeTypeId.ImageHeif }
    case "hs": return { value: EntityMimeTypeId.TextPlain }
    case "html": return { value: EntityMimeTypeId.TextHtml }
    case "ico": return { value: EntityMimeTypeId.ImageIco }
    case "ics": return { value: EntityMimeTypeId.TextIcs }
    case "java": return { value: EntityMimeTypeId.TextPlain }
    case "jl": return { value: EntityMimeTypeId.TextPlain }
    case "jp2": return { value: EntityMimeTypeId.ImageJp2 }
    case "jpeg": return { value: EntityMimeTypeId.ImageJpeg }
    case "jpg": return { value: EntityMimeTypeId.ImageJpeg }
    case "js": return { value: EntityMimeTypeId.TextJavascript }
    case "jsx": return { value: EntityMimeTypeId.TextPlain }
    case "jxl": return { value: EntityMimeTypeId.ImageJxl }
    case "jxr": return { value: EntityMimeTypeId.ImageJxr }
    case "key": return { value: EntityMimeTypeId.PresentationKeynote }
    case "kt": return { value: EntityMimeTypeId.TextPlain }
    case "lz": return { value: EntityMimeTypeId.ArchiveLz }
    case "m4a": return { value: EntityMimeTypeId.AudioM4a }
    case "m4v": return { value: EntityMimeTypeId.VideoM4v }
    case "mach": return { value: EntityMimeTypeId.ApplicationMach }
    case "md": return { value: EntityMimeTypeId.TextMarkdown }
    case "midi": return { value: EntityMimeTypeId.AudioMidi }
    case "mkv": return { value: EntityMimeTypeId.VideoMkv }
    case "mobi": return { value: EntityMimeTypeId.BookMobi }
    case "mov": return { value: EntityMimeTypeId.VideoMov }
    case "mp3": return { value: EntityMimeTypeId.AudioMp3 }
    case "mp4": return { value: EntityMimeTypeId.VideoMp4 }
    case "mpg": return { value: EntityMimeTypeId.VideoMpg }
    case "msi": return { value: EntityMimeTypeId.ArchiveMsi }
    case "nes": return { value: EntityMimeTypeId.ArchiveNes }
    case "numbers": return { value: EntityMimeTypeId.SpreadsheetNumbers }
    case "obj": return { value: EntityMimeTypeId.ApplicationObj }
    case "odp": return { value: EntityMimeTypeId.PresentationOdp }
    case "ods": return { value: EntityMimeTypeId.SpreadsheetOds }
    case "odt": return { value: EntityMimeTypeId.DocOdt }
    case "ogg": return { value: EntityMimeTypeId.AudioOgg }
    case "opus": return { value: EntityMimeTypeId.AudioOpus }
    case "ora": return { value: EntityMimeTypeId.ImageOra }
    case "otf": return { value: EntityMimeTypeId.FontOtf }
    case "pages": return { value: EntityMimeTypeId.DocPages }
    case "pdf": return { value: EntityMimeTypeId.ApplicationPdf }
    case "php": return { value: EntityMimeTypeId.TextPlain }
    case "pl": return { value: EntityMimeTypeId.TextPlain }
    case "png": return { value: EntityMimeTypeId.ImagePng }
    case "ppt": return { value: EntityMimeTypeId.PresentationPpt }
    case "pptx": return { value: EntityMimeTypeId.PresentationPptx }
    case "ps": return { value: EntityMimeTypeId.ArchivePs }
    case "psd": return { value: EntityMimeTypeId.ImagePsd }
    case "py": return { value: EntityMimeTypeId.TextPython }
    case "r": return { value: EntityMimeTypeId.TextPlain }
    case "rar": return { value: EntityMimeTypeId.ArchiveRar }
    case "rb": return { value: EntityMimeTypeId.TextPlain }
    case "rpm": return { value: EntityMimeTypeId.ArchiveRpm }
    case "rs": return { value: EntityMimeTypeId.TextPlain }
    case "rtf": return { value: EntityMimeTypeId.TextRtf }
    case "scala": return { value: EntityMimeTypeId.TextPlain }
    case "sh": return { value: EntityMimeTypeId.TextSh }
    case "sql": return { value: EntityMimeTypeId.TextPlain }
    case "sqlite": return { value: EntityMimeTypeId.ArchiveSqlite }
    case "svg": return { value: EntityMimeTypeId.ImageSvg }
    case "swf": return { value: EntityMimeTypeId.ArchiveSwf }
    case "swift": return { value: EntityMimeTypeId.TextPlain }
    case "tar": return { value: EntityMimeTypeId.ArchiveTar }
    case "tif": return { value: EntityMimeTypeId.ImageTif }
    case "ts": return { value: EntityMimeTypeId.TextPlain }
    case "tsx": return { value: EntityMimeTypeId.TextPlain }
    case "ttf": return { value: EntityMimeTypeId.FontTtf }
    case "txt": return { value: EntityMimeTypeId.TextPlain }
    case "url": return { value: EntityMimeTypeId.TextUriList }
    case "vue": return { value: EntityMimeTypeId.TextPlain }
    case "wasm": return { value: EntityMimeTypeId.ApplicationWasm }
    case "wav": return { value: EntityMimeTypeId.AudioWav }
    case "webloc": return { value: EntityMimeTypeId.TextUriList }
    case "webm": return { value: EntityMimeTypeId.VideoWebm }
    case "webp": return { value: EntityMimeTypeId.ImageWebp }
    case "wmv": return { value: EntityMimeTypeId.VideoWmv }
    case "woff": return { value: EntityMimeTypeId.FontWoff }
    case "woff2": return { value: EntityMimeTypeId.FontWoff2 }
    case "xls": return { value: EntityMimeTypeId.SpreadsheetXls }
    case "xlsx": return { value: EntityMimeTypeId.SpreadsheetXlsx }
    case "xz": return { value: EntityMimeTypeId.ArchiveXz }
    case "yml": return { value: EntityMimeTypeId.TextPlain }
    case "z": return { value: EntityMimeTypeId.ArchiveZ }
    case "zip": return { value: EntityMimeTypeId.ArchiveZip }
    case "zst": return { value: EntityMimeTypeId.ArchiveZst }
    default: return { value: EntityMimeTypeId.Unknown, unknown: "application/octet-stream" }
  }
}
export function mediaType(mimeType: EntityMimeType): EntityMediaType {
  switch (mimeType.value) {
    case EntityMimeTypeId.Unknown:
    case EntityMimeTypeId.ApplicationBc:
    case EntityMimeTypeId.ApplicationClass:
    case EntityMimeTypeId.ApplicationMach:
    case EntityMimeTypeId.ApplicationMsgpack:
    case EntityMimeTypeId.ApplicationObj:
    case EntityMimeTypeId.ApplicationOctetStream:
    case EntityMimeTypeId.ApplicationWasm:
    case EntityMimeTypeId.ApplicationWwwFormUrlencoded:
    case EntityMimeTypeId.FontOtf:
    case EntityMimeTypeId.FontTtf:
    case EntityMimeTypeId.FontWoff:
    case EntityMimeTypeId.FontWoff2:
    case EntityMimeTypeId.InodeSymlink:
    case EntityMimeTypeId.MultipartFormData:
    case EntityMimeTypeId.TextIcs:
    case EntityMimeTypeId.TextVcard:
      return "unknown"
    case EntityMimeTypeId.ApplicationExe:
      return "executable"
    case EntityMimeTypeId.ApplicationJavascript:
    case EntityMimeTypeId.ApplicationJson:
    case EntityMimeTypeId.TextCss:
    case EntityMimeTypeId.TextCsv:
    case EntityMimeTypeId.TextEventStream:
    case EntityMimeTypeId.TextHtml:
    case EntityMimeTypeId.TextJavascript:
    case EntityMimeTypeId.TextPython:
    case EntityMimeTypeId.TextMarkdown:
    case EntityMimeTypeId.TextPlain:
    case EntityMimeTypeId.TextXml:
      return "text"
    case EntityMimeTypeId.ApplicationPdf:
      return "pdf"
    case EntityMimeTypeId.Archive7z:
    case EntityMimeTypeId.ArchiveAr:
    case EntityMimeTypeId.ArchiveBz2:
    case EntityMimeTypeId.ArchiveCab:
    case EntityMimeTypeId.ArchiveCpio:
    case EntityMimeTypeId.ArchiveCrx:
    case EntityMimeTypeId.ArchiveDcm:
    case EntityMimeTypeId.ArchiveDeb:
    case EntityMimeTypeId.ArchiveGz:
    case EntityMimeTypeId.ArchiveLz:
    case EntityMimeTypeId.ArchiveMsi:
    case EntityMimeTypeId.ArchiveNes:
    case EntityMimeTypeId.ArchivePs:
    case EntityMimeTypeId.ArchiveRar:
    case EntityMimeTypeId.ArchiveRpm:
    case EntityMimeTypeId.ArchiveRtf:
    case EntityMimeTypeId.ArchiveSqlite:
    case EntityMimeTypeId.ArchiveSwf:
    case EntityMimeTypeId.ArchiveTar:
    case EntityMimeTypeId.ArchiveXz:
    case EntityMimeTypeId.ArchiveZ:
    case EntityMimeTypeId.ArchiveZip:
    case EntityMimeTypeId.ArchiveZst:
      return "archive"
    case EntityMimeTypeId.AudioAac:
    case EntityMimeTypeId.AudioAiff:
    case EntityMimeTypeId.AudioAmr:
    case EntityMimeTypeId.AudioApe:
    case EntityMimeTypeId.AudioDsf:
    case EntityMimeTypeId.AudioFlac:
    case EntityMimeTypeId.AudioM4a:
    case EntityMimeTypeId.AudioMidi:
    case EntityMimeTypeId.AudioMp3:
    case EntityMimeTypeId.AudioMp4:
    case EntityMimeTypeId.AudioOgg:
    case EntityMimeTypeId.AudioOpus:
    case EntityMimeTypeId.AudioWav:
      return "audio"
    case EntityMimeTypeId.BookEpub:
    case EntityMimeTypeId.BookMobi:
    case EntityMimeTypeId.DocDoc:
    case EntityMimeTypeId.DocDocm:
    case EntityMimeTypeId.DocDocx:
    case EntityMimeTypeId.DocOdt:
    case EntityMimeTypeId.DocPages:
      return "document"
    case EntityMimeTypeId.ImageAvif:
    case EntityMimeTypeId.ImageBmp:
    case EntityMimeTypeId.ImageCr2:
    case EntityMimeTypeId.ImageGif:
    case EntityMimeTypeId.ImageHeic:
    case EntityMimeTypeId.ImageHeif:
    case EntityMimeTypeId.ImageIco:
    case EntityMimeTypeId.ImageJp2:
    case EntityMimeTypeId.ImageJpeg:
    case EntityMimeTypeId.ImageJxl:
    case EntityMimeTypeId.ImageJxr:
    case EntityMimeTypeId.ImageOra:
    case EntityMimeTypeId.ImagePng:
    case EntityMimeTypeId.ImagePpm:
    case EntityMimeTypeId.ImagePsd:
    case EntityMimeTypeId.ImageQoi:
    case EntityMimeTypeId.ImageStar:
    case EntityMimeTypeId.ImageSvg:
    case EntityMimeTypeId.ImageTif:
    case EntityMimeTypeId.ImageWebp:
      return "image"
    case EntityMimeTypeId.InodeDirectory:
      return "folder"
    case EntityMimeTypeId.PresentationKeynote:
    case EntityMimeTypeId.PresentationOdp:
    case EntityMimeTypeId.PresentationPpt:
    case EntityMimeTypeId.PresentationPptx:
      return "presentation"
    case EntityMimeTypeId.SpreadsheetNumbers:
    case EntityMimeTypeId.SpreadsheetOds:
    case EntityMimeTypeId.SpreadsheetXls:
    case EntityMimeTypeId.SpreadsheetXlsx:
    case EntityMimeTypeId.TextTabSeparatedValues:
      return "spreadsheet"
    case EntityMimeTypeId.TextUriList:
    case EntityMimeTypeId.VendorYoutubeVideo:
      return "link"
    case EntityMimeTypeId.VideoAvi:
    case EntityMimeTypeId.VideoFlv:
    case EntityMimeTypeId.VideoM4v:
    case EntityMimeTypeId.VideoMkv:
    case EntityMimeTypeId.VideoMov:
    case EntityMimeTypeId.VideoMp4:
    case EntityMimeTypeId.VideoMpg:
    case EntityMimeTypeId.VideoWebm:
    case EntityMimeTypeId.VideoWmv:
      return "video"
    default:
      return "unknown"
  }
}
